"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-container" };
const Appointments_vue_1 = __importDefault(require("./Appointments.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'Home',
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(Appointments_vue_1.default)
            ]));
        };
    }
});
